// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.edit-dashboard-state-parent-container{
    position: absolute;
    top: 0;
    left: 0;
    z-index: 10;
    width: 100vw;
    height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: rgba(0, 0, 0, 0.45);
    font-family: "Segoe UI", Tahoma, Geneva, Verdana, sans-serif;
}
.edit-dashboard-state-container{
    position: absolute;
    width: 500px;
    border-radius: 5px;
    background-color: white;
    box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.5);
}
.edit-dashboard-state-header{
    margin: 0px;
    padding: 10px 25px;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    box-sizing: border-box;
    border-radius: 5px 5px 0px 0px;
    background-color: rgba(155, 30, 30, 0.952);
}
.edit-dashboard-state-header h3{
    margin: 0px;
    color: white;
    font-size: 22px;
    font-weight: 600;
}
.edit-dashboard-state-header p{
    margin: 0px;
    color: white;
    cursor: pointer;
    font-size: 22px;
    font-weight: 400;
}
.edit-dashboard-state-entry-container{
    position: relative;
    margin: 32px 24px;
    padding: 4px 10px;
    box-sizing: border-box;
    background-color: rgba(222, 229, 233, 0.6);
    border-bottom: 1px solid rgb(128, 128, 128);
}
.edit-dashboard-state-entry-container:focus-within{
    border-bottom: 1px solid rgba(155, 30, 30, 0.952);
}
.edit-dashboard-state-entry-container p{
    margin: 0px;
    font-size: 12px;
    color: rgb(88, 88, 88);
}
.edit-dashboard-state-entry-container p span{
    color: red;
}
.edit-dashboard-state-entry-container input{
    width: 100%;
    border: none;
    outline: none;
    background-color: transparent;
}
.edit-dashboard-state-checkboxes-container{
    margin: 12px 24px;
    display: flex;
    align-items: center;
    justify-content: space-between;
}
.edit-dashboard-state-checkboxes-container label{
    display: flex;
    align-items: center;
}
.edit-dashboard-state-checkboxes-container input{
    zoom: 1.4;
    cursor: pointer;
}
.edit-dashboard-state-checkboxes-container label span{
    margin: 0px;
    cursor: pointer;
    margin-bottom: 4px;
}
.edit-dashboard-state-buttons-container{
    text-align: right;
    padding: 10px 24px;
    padding-bottom: 20px;
}
.edit-dashboard-state-buttons-container button{
    border: none;
    font-weight: 600;
    margin-left: 12px;
    border-radius: 4px;
    padding: 8px 24px;
    padding-bottom: 10px;
    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
}
.edit-dashboard-state-buttons-container .cancel-button{
    cursor: pointer;
    color: rgba(155, 30, 30, 0.952);
}
.edit-dashboard-state-buttons-container .cancel-button:hover{
    background-color: rgb(226, 226, 226);
}
.edit-dashboard-state-buttons-container .save-button.active{
    cursor: pointer;
    color: white;
    box-shadow: 0px 0px 8px rgba(0, 0, 0, 0.25);
    background-color: rgba(155, 30, 30, 0.952);
}
.edit-dashboard-state-buttons-container .save-button.active:hover{
    background-color: rgba(187, 69, 69, 0.952);
}
.edit-dashboard-state-buttons-container .save-button.inactive{
    cursor: default;
    color: rgb(160, 160, 160);
    background-color: rgb(240, 240, 240);
}`, "",{"version":3,"sources":["webpack://./src/styles/workspace_styles/TenantAdministratorStyles/Dashboards/EditDashboardState.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,aAAa;IACb,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,qCAAqC;IACrC,4DAA4D;AAChE;AACA;IACI,kBAAkB;IAClB,YAAY;IACZ,kBAAkB;IAClB,uBAAuB;IACvB,0CAA0C;AAC9C;AACA;IACI,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,sBAAsB;IACtB,8BAA8B;IAC9B,0CAA0C;AAC9C;AACA;IACI,WAAW;IACX,YAAY;IACZ,eAAe;IACf,gBAAgB;AACpB;AACA;IACI,WAAW;IACX,YAAY;IACZ,eAAe;IACf,eAAe;IACf,gBAAgB;AACpB;AACA;IACI,kBAAkB;IAClB,iBAAiB;IACjB,iBAAiB;IACjB,sBAAsB;IACtB,0CAA0C;IAC1C,2CAA2C;AAC/C;AACA;IACI,iDAAiD;AACrD;AACA;IACI,WAAW;IACX,eAAe;IACf,sBAAsB;AAC1B;AACA;IACI,UAAU;AACd;AACA;IACI,WAAW;IACX,YAAY;IACZ,aAAa;IACb,6BAA6B;AACjC;AACA;IACI,iBAAiB;IACjB,aAAa;IACb,mBAAmB;IACnB,8BAA8B;AAClC;AACA;IACI,aAAa;IACb,mBAAmB;AACvB;AACA;IACI,SAAS;IACT,eAAe;AACnB;AACA;IACI,WAAW;IACX,eAAe;IACf,kBAAkB;AACtB;AACA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,oBAAoB;AACxB;AACA;IACI,YAAY;IACZ,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;IAClB,iBAAiB;IACjB,oBAAoB;IACpB,4DAA4D;AAChE;AACA;IACI,eAAe;IACf,+BAA+B;AACnC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,eAAe;IACf,YAAY;IACZ,2CAA2C;IAC3C,0CAA0C;AAC9C;AACA;IACI,0CAA0C;AAC9C;AACA;IACI,eAAe;IACf,yBAAyB;IACzB,oCAAoC;AACxC","sourcesContent":[".edit-dashboard-state-parent-container{\r\n    position: absolute;\r\n    top: 0;\r\n    left: 0;\r\n    z-index: 10;\r\n    width: 100vw;\r\n    height: 100vh;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    background-color: rgba(0, 0, 0, 0.45);\r\n    font-family: \"Segoe UI\", Tahoma, Geneva, Verdana, sans-serif;\r\n}\r\n.edit-dashboard-state-container{\r\n    position: absolute;\r\n    width: 500px;\r\n    border-radius: 5px;\r\n    background-color: white;\r\n    box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.5);\r\n}\r\n.edit-dashboard-state-header{\r\n    margin: 0px;\r\n    padding: 10px 25px;\r\n    width: 100%;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: space-between;\r\n    box-sizing: border-box;\r\n    border-radius: 5px 5px 0px 0px;\r\n    background-color: rgba(155, 30, 30, 0.952);\r\n}\r\n.edit-dashboard-state-header h3{\r\n    margin: 0px;\r\n    color: white;\r\n    font-size: 22px;\r\n    font-weight: 600;\r\n}\r\n.edit-dashboard-state-header p{\r\n    margin: 0px;\r\n    color: white;\r\n    cursor: pointer;\r\n    font-size: 22px;\r\n    font-weight: 400;\r\n}\r\n.edit-dashboard-state-entry-container{\r\n    position: relative;\r\n    margin: 32px 24px;\r\n    padding: 4px 10px;\r\n    box-sizing: border-box;\r\n    background-color: rgba(222, 229, 233, 0.6);\r\n    border-bottom: 1px solid rgb(128, 128, 128);\r\n}\r\n.edit-dashboard-state-entry-container:focus-within{\r\n    border-bottom: 1px solid rgba(155, 30, 30, 0.952);\r\n}\r\n.edit-dashboard-state-entry-container p{\r\n    margin: 0px;\r\n    font-size: 12px;\r\n    color: rgb(88, 88, 88);\r\n}\r\n.edit-dashboard-state-entry-container p span{\r\n    color: red;\r\n}\r\n.edit-dashboard-state-entry-container input{\r\n    width: 100%;\r\n    border: none;\r\n    outline: none;\r\n    background-color: transparent;\r\n}\r\n.edit-dashboard-state-checkboxes-container{\r\n    margin: 12px 24px;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: space-between;\r\n}\r\n.edit-dashboard-state-checkboxes-container label{\r\n    display: flex;\r\n    align-items: center;\r\n}\r\n.edit-dashboard-state-checkboxes-container input{\r\n    zoom: 1.4;\r\n    cursor: pointer;\r\n}\r\n.edit-dashboard-state-checkboxes-container label span{\r\n    margin: 0px;\r\n    cursor: pointer;\r\n    margin-bottom: 4px;\r\n}\r\n.edit-dashboard-state-buttons-container{\r\n    text-align: right;\r\n    padding: 10px 24px;\r\n    padding-bottom: 20px;\r\n}\r\n.edit-dashboard-state-buttons-container button{\r\n    border: none;\r\n    font-weight: 600;\r\n    margin-left: 12px;\r\n    border-radius: 4px;\r\n    padding: 8px 24px;\r\n    padding-bottom: 10px;\r\n    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;\r\n}\r\n.edit-dashboard-state-buttons-container .cancel-button{\r\n    cursor: pointer;\r\n    color: rgba(155, 30, 30, 0.952);\r\n}\r\n.edit-dashboard-state-buttons-container .cancel-button:hover{\r\n    background-color: rgb(226, 226, 226);\r\n}\r\n.edit-dashboard-state-buttons-container .save-button.active{\r\n    cursor: pointer;\r\n    color: white;\r\n    box-shadow: 0px 0px 8px rgba(0, 0, 0, 0.25);\r\n    background-color: rgba(155, 30, 30, 0.952);\r\n}\r\n.edit-dashboard-state-buttons-container .save-button.active:hover{\r\n    background-color: rgba(187, 69, 69, 0.952);\r\n}\r\n.edit-dashboard-state-buttons-container .save-button.inactive{\r\n    cursor: default;\r\n    color: rgb(160, 160, 160);\r\n    background-color: rgb(240, 240, 240);\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
